<template>
  <v-dialog v-model="dialogframeboton" persistent fullscreen>
    <v-card>
      <v-toolbar dark color="red-darken-4">
        <v-toolbar-title
          ><v-icon left>{{ iconodialogbtn }}</v-icon> {{ titledialogbtn }} -
          {{ infollaves.Contrato }} - {{ infollaves.Ref_1 }} -
          {{ infollaves.Document_ID }} - {{ infollaves.Primer_Nombre }}
          {{ infollaves.Segundo_Nombre }} {{ infollaves.Primer_Apellido }}
          {{ infollaves.Segundo_Apellido }}
        </v-toolbar-title>
        <v-toolbar-items>
          <v-btn class="d-none d-md-block" dark text @click="CerrarCombos()"
            >Cerrar</v-btn
          >
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <!-- Clientes ¡-->
        <card-clientes
          v-if="componenteview == 1"
          v-bind:pageiframe="dialogframeboton"
          v-on:update:pageiframe="dialogframeboton = $event"
          :infollaves="llaves"
          :infopermisos="'0010'"
        ></card-clientes>
        <!-- Consulta  Contratos ¡-->
        <card-contratos
          v-else-if="componenteview == 2"
          v-bind:pageiframe="dialogframeboton"
          v-on:update:pageiframe="dialogframeboton = $event"
          :infollaves="llaves"
          :infopermisos="'0010'"
        ></card-contratos>
        <!-- Consulta  Activos ¡-->
        <card-activos
          v-else-if="componenteview == 3"
          v-bind:pageiframe="dialogframeboton"
          v-on:update:pageiframe="dialogframeboton = $event"
          :infollaves="llaves"
          :infopermisos="'0010'"
        ></card-activos>
        <!-- Documentos -->
        <card-documentos
          v-else-if="componenteview == 4"
          :infollaves="llaves"
        ></card-documentos>
        <!-- Consulta Documentos ¡-->
        <card-consultadocumentos
          v-else-if="componenteview == 5"
          :infollaves="llaves"
        ></card-consultadocumentos>
      </v-card-text>
    </v-card>
  </v-dialog>
  <!-- Tablero de control -->
  <v-data-table
    v-model="selected"
    v-model:page="itemsPerPage"
    :headers="headers"
    :items="desserts"
    :search="search"
    item-value="SeguroID"
    show-select
    return-object
    height="550px"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <!-- Campos -->
        <v-dialog v-model="dialogframecreate" persistent max-width="1500px">
          <template v-if="param1[1] == '1'" v-slot:activator="{ props }">
            <v-btn
              color="green"
              icon="mdi-plus"
              size="x-large"
              dark
              class="mb-2"
              v-bind="props"
              @click="CargueCombo"
            >
            </v-btn>
          </template>
          <v-card>
            <v-toolbar dark color="red-darken-4">
              <v-toolbar-title
                ><v-icon left>{{ iconTitle }}</v-icon> {{ formTitle }}
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn
                  class="d-none d-md-block"
                  dark
                  text
                  @click="
                    dialogframecreate = false;
                    editedItem = null;
                    editedIndex = -1;
                  "
                  >Cerrar</v-btn
                >
              </v-toolbar-items>
            </v-toolbar>
            <v-card-text>
              <proceso-registro
                v-if="dialogframecreate"
                :infoedit="editedItem"
                v-bind:page="dialogframecreate"
                v-on:update:page="dialogframecreate = $event"
                v-bind:Exito="respuestapostput"
                v-on:update:Exito="respuestapostput = $event"
                v-bind:componenteview="componenteview"
                v-on:update:componenteview="componenteview = $event"
                v-bind:pageiframe="dialogframeboton"
                v-on:update:pageiframe="dialogframeboton = $event"
                v-bind:titledialogbtn="titledialogbtn"
                v-on:update:titledialogbtn="titledialogbtn = $event"
                v-bind:iconodialogbtn="iconodialogbtn"
                v-on:update:iconodialogbtn="iconodialogbtn = $event"
                :infopermisos="param1"
                :editedIndex="editedIndex"
                :infollaves="infollaves"
                :TipoSeguro="TipoSeguro"
              ></proceso-registro>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-divider
          v-if="param1[1] == '1'"
          class="mx-4"
          inset
          vertical
        ></v-divider>
        <!-- Eliminación -->
        <v-btn
          v-if="param1[3] == '1'"
          color="red"
          icon="mdi-delete"
          dark
          class="mb-2"
          @click="Eliminar"
        >
        </v-btn>
        <v-divider
          v-if="param1[3] == '1'"
          class="mx-4"
          inset
          vertical
        ></v-divider>
        <!-- Filtros -->
        <v-dialog v-model="dialogframe" persistent max-width="1000px">
          <template v-slot:activator="{ props }">
            <v-btn
              color="cyan"
              icon="mdi-filter-menu"
              dark
              class="mb-2"
              v-bind="props"
              @click="CargueCombo"
            >
            </v-btn>
          </template>
          <v-card>
            <v-toolbar dark color="red-darken-4">
              <v-toolbar-title
                ><v-icon left>mdi-filter-menu</v-icon> Filtros
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn class="d-none d-md-block" dark text @click="reset"
                  >Limpiar</v-btn
                >
                <v-btn
                  class="d-none d-md-block"
                  dark
                  text
                  @click="ValidateCampos"
                  >Consultar</v-btn
                >
                <v-btn
                  class="d-none d-md-block"
                  dark
                  text
                  @click="dialogframe = false"
                  >Cerrar</v-btn
                >
              </v-toolbar-items>
            </v-toolbar>
            <v-card-text>
              <v-form ref="form" autocomplete="off">
                <v-row v-for="(datos, i) in modelfiltro" :key="i">
                  <!-- Filtro -->
                  <v-col cols="6">
                    <v-autocomplete
                      v-model="datos.filtro"
                      :items="items"
                      item-title="descripcion"
                      item-value="filtro"
                      label="Tipo de filtro:"
                      :clearable="datos.clear"
                      :readonly="datos.lectura"
                    ></v-autocomplete>
                  </v-col>
                  <!-- Contenido -->
                  <!--Tipo de Seguro -->
                  <v-col v-if="i == 4" cols="6">
                    <v-autocomplete
                      v-model="datos.contenido"
                      :items="ArrayTipoSeguro"
                      :item-title="
                        (ArrayTipoSeguro) =>
                          ArrayTipoSeguro.Valor +
                          '-' +
                          ArrayTipoSeguro.Descripcion
                      "
                      item-value="Valor"
                      :label="datos.label"
                      dense
                      clearable
                    >
                    </v-autocomplete>
                  </v-col>
                  <!--Estado de póliza -->
                  <v-col v-else-if="i == 7" cols="6">
                    <v-autocomplete
                      v-model="datos.contenido"
                      :items="ArrayEstado"
                      :item-title="
                        (ArrayEstado) =>
                          ArrayEstado.Valor + '-' + ArrayEstado.Descripcion
                      "
                      item-value="Valor"
                      :label="datos.label"
                      dense
                      clearable
                    >
                    </v-autocomplete>
                  </v-col>
                  <!-- Tipo de poliza -->
                  <v-col v-else-if="i == 8" cols="6">
                    <v-autocomplete
                      v-model="datos.contenido"
                      :items="ArrayTipoPoliza"
                      :item-title="
                        (ArrayTipoPoliza) =>
                          ArrayTipoPoliza.Valor +
                          '-' +
                          ArrayTipoPoliza.Descripcion
                      "
                      item-value="Valor"
                      color="primary"
                      :label="datos.label"
                      dense
                      :rules="[(v) => !!v || 'Campo obligatorio']"
                      clearable
                    >
                    </v-autocomplete>
                  </v-col>
                  <!-- Clase de poliza -->
                  <v-col v-else-if="i == 9" cols="6">
                    <v-autocomplete
                      v-model="datos.contenido"
                      :items="ArrayClasePoliza"
                      :item-title="
                        (ArrayClasePoliza) =>
                          ArrayClasePoliza.Valor +
                          '-' +
                          ArrayClasePoliza.Descripcion
                      "
                      item-value="Valor"
                      color="primary"
                      :label="datos.label"
                      dense
                      :rules="[(v) => !!v || 'Campo obligatorio']"
                      clearable
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col v-else cols="6">
                    <v-text-field
                      v-model="datos.contenido"
                      :label="datos.label"
                      :type="i == 10 || i == 11 ? 'date' : ''"
                      :clearable="datos.clear"
                      :readonly="datos.lectura"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <!-- Buscador -->
        <v-text-field
          v-model="search"
          append-inner-icon="mdi-magnify"
          label="Buscar..."
          single-line
          variant="underlined"
          hide-details
        ></v-text-field>
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <div class="text-center">
        <v-menu
          v-model="menubuttoms[item.raw.SeguroID]"
          :close-on-content-click="false"
          :nudge-width="200"
          offset-x
        >
          <template v-slot:activator="{ props }">
            <v-icon color="red-darken-4" v-bind="props">
              mdi-file-settings</v-icon
            >
          </template>
          <v-card flat>
            <v-card-text>
              <v-container>
                <v-row>
                  <!-- Modificación  -->
                  <v-tooltip
                    v-if="param1[2] == '1' || param1[0] == '1'"
                    location="bottom"
                    color="white"
                  >
                    <template v-slot:activator="{ props }">
                      <v-icon
                        color="#05AD58"
                        @click="editItem(item.raw, 0)"
                        v-bind="props"
                        >{{
                          param1[2] == "1" && param1[0] == "0"
                            ? "mdi-pencil"
                            : "mdi-eye"
                        }}</v-icon
                      >
                    </template>
                    <span>{{
                      param1[2] == "1" && param1[0] == "0"
                        ? "Modificar"
                        : "Consultar"
                    }}</span>
                  </v-tooltip>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <!-- Cliente -->
                  <v-tooltip location="bottom" color="white">
                    <template v-slot:activator="{ props }">
                      <v-icon
                        @click="editItem(item.raw, 1)"
                        color="cyan"
                        v-bind="props"
                        >mdi-account</v-icon
                      >
                    </template>
                    <span>Cliente</span>
                  </v-tooltip>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <!-- Contrato -->
                  <v-tooltip location="bottom" color="white">
                    <template v-slot:activator="{ props }">
                      <v-icon
                        @click="editItem(item.raw, 2)"
                        color="red"
                        v-bind="props"
                        >mdi-note</v-icon
                      >
                    </template>
                    <span>Contrato</span>
                  </v-tooltip>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <!-- Seguros -->
                  <v-tooltip location="bottom" color="white">
                    <template v-slot:activator="{ props }">
                      <v-icon
                        @click="editItem(item.raw, 3)"
                        color="cyan"
                        v-bind="props"
                        >mdi-home-group</v-icon
                      >
                    </template>
                    <span>Activos</span>
                  </v-tooltip>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <!-- Anexar Documento -->
                  <v-tooltip location="bottom" color="white">
                    <template v-slot:activator="{ props }">
                      <v-icon
                        @click="editItem(item.raw, 4)"
                        color="indigo"
                        v-bind="props"
                        >mdi-folder-open</v-icon
                      >
                    </template>
                    <span>Anexar Documento</span>
                  </v-tooltip>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <!-- Consultar Documento -->
                  <v-tooltip location="bottom" color="white">
                    <template v-slot:activator="{ props }">
                      <v-icon
                        @click="editItem(item.raw, 5)"
                        color="purple"
                        v-bind="props"
                        >mdi-file-search</v-icon
                      >
                    </template>
                    <span>Consulta documentos</span>
                  </v-tooltip>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-menu>
      </div>
    </template>
  </v-data-table>

  <!-- Linea de progreso -->
  <div class="d-flex align-center flex-column">
    <v-dialog v-model="progreso" persistent width="auto">
      <v-card color="red-darken-4">
        <v-card-text>
          Espera un momento...
          <v-toolbar align="center" color="red-darken-4">
            <v-img
              class="mx-auto"
              :width="5"
              src="/static/iconos/logo2.png"
            ></v-img>
          </v-toolbar>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Registro from "@/views/TCI/ActivosO/Seguros/SegurosRegistro.vue";
import DocumentosComponents from "@/views/TCI/Documentos/DocumentosComponents/DocumentosComponentsActivos.vue";
import ConsultaDocumentos from "@/views/TCI/Documentos/ConsultaDocumentos/ConsultaDocumentos.vue";
import Activos from "@/views/TCI/ActivosO/Activos/Activos.vue";
import Contrato from "@/views/TCI/ActivosO/Contratos/Contratos.vue";
import Clientes from "@/views/TCI/Personas/Clientes/Clientes.vue";
export default {
  name: "Seguros",
  props: {
    infollaves: {
      type: Object,
      default: null,
      Description: "Información de llaves",
    },
    infopermisos: {
      type: String,
      default: "",
      Description: "Información de permisos",
    },
    pageiframe: {
      type: Boolean,
      default: false,
      Description: "Saber desde donde se llama la página",
    },
    paramiframeuno: {
      type: String,
      default: "0",
      Description: "Parametro enviado de la pantalla principal",
    },
    TipoSeguro: {
      type: String,
      default: null,
      Description: "Información de Tipo de seguro",
    },
  },
  components: {
    "proceso-registro": Registro,
    "card-clientes": Clientes,
    "card-contratos": Contrato,
    "card-activos": Activos,
    "card-consultadocumentos": ConsultaDocumentos,
    "card-documentos": DocumentosComponents,
  },
  data() {
    return {
      itemsPerPage: 1,
      selected: [],
      search: "",
      editedItem: null,
      editedIndex: -1,
      respuestapostput: "",
      consult: false,
      progreso: false,
      dialogframe: false,
      dialogframecreate: false,
      dialogframeboton: false,
      iconodialogbtn: "",
      titledialogbtn: "",
      componenteview: 0,
      menubuttoms: [],
      items: [
        {
          filtro: "=",
          descripcion: "Igual a",
        },
        {
          filtro: "LIKE",
          descripcion: "Similar a",
        },
        {
          filtro: ">=",
          descripcion: "Mayor igual a",
        },
        {
          filtro: "<=",
          descripcion: "Menor igual a",
        },
      ],
      modelfiltro: [
        {
          campo: "TipoDocumentoID",
          filtro: null,
          contenido: null,
          lectura: true,
          clear: false,
          label: "Tipo de documento:",
        },
        {
          campo: "DocumentoID",
          filtro: null,
          contenido: null,
          lectura: true,
          clear: false,
          label: "Documento:",
        },
        {
          campo: "ContratoID",
          filtro: null,
          contenido: null,
          lectura: true,
          clear: false,
          label: "Contrato:",
        },
        {
          campo: "Ref1",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Activo:",
        },
        {
          campo: "TipoSeguro",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Tipo de seguro:",
        },
        {
          campo: "Poliza",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Poliza:",
        },
        {
          campo: "Anexo",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Anexo:",
        },
        {
          campo: "EstadoPoliza",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Estado de poliza:",
        },
        {
          campo: "TipoPoliza",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Tipo poliza:",
        },
        {
          campo: "ClasePoliza",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Clase de poliza:",
        },
        {
          campo: "FechaInicial",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Fecha Inicial:",
        },
        {
          campo: "FechaFinal",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Fecha de vencimiento:",
        },
        {
          campo: "SeguroID",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "ID Seguro:",
        },
      ],
      headers: [
        {
          title: "Acciones",
          key: "actions",
          align: "center",
          sortable: false,
        },
        {
          title: "Tipo de seguro",
          key: "DescTipoSeguro",
        },
        {
          title: "Póliza",
          key: "Poliza",
        },
        {
          title: "Anexo",
          key: "Anexo",
        },
        {
          title: "Estado",
          key: "DescEstadoPoliza",
        },
        {
          title: "Tipo póliza",
          key: "DescTipoPoliza",
        },
        {
          title: "Clase de Póliza",
          key: "DescClasePoliza",
        },
        {
          title: "Fecha de vencimiento",
          key: "FechaFinal",
        },
      ],
      llaves: {
        TypeDocument_ID: null,
        Document_ID: null,
        Primer_Apellido: null,
        Segundo_Apellido: null,
        Primer_Nombre: null,
        Segundo_Nombre: null,
        Solicitud: null,
        Contrato: null,
        Ref_1: null,
        Ref_2: null,
        Ref_3: null,
        IDServicio: null,
        IDPoliza: null,
        Secuencia_ID: null,
      },
      desserts: [],
      ArrayTipoSeguro: [],
      ArrayEstado: [],
      ArrayClasePoliza: [],
      ArrayTipoPoliza: [],
      param1: [],
      busquedacompleta: false,
    };
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "Crear Registro"
        : this.param1[2] == "1" && this.param1[0] == "0"
        ? "Actualizar registro"
        : "Consultar registro";
    },
    iconTitle() {
      return this.editedIndex === -1
        ? "mdi-plus"
        : this.param1[2] == "1" && this.param1[0] == "0"
        ? "mdi-pencil"
        : "mdi-eye";
    },
  },
  watch: {
    dialogframecreate(val) {
      if (!val && this.respuestapostput == "Exito" && this.consult) {
        this.respuestapostput = null;
        this.ValidateCampos();
        this.itemsPerPage = 1;
      }
    },
  },
  methods: {
    ///////////////////////////////////////////////// Métodos de consulta ///////////////////////////////////////////
    // Validación de campos
    async ValidateCampos() {
      var validate = false;
      this.busquedacompleta = false;
      this.consult = validate;
      for (var i = 0; i < this.modelfiltro.length; i++) {
        if (
          (this.modelfiltro[i].filtro == "" ||
            this.modelfiltro[i].filtro == null) &&
          this.modelfiltro[i].contenido != "" &&
          this.modelfiltro[i].contenido != null
        ) {
          validate = true;
        } else if (
          (this.modelfiltro[i].contenido == "" ||
            this.modelfiltro[i].contenido == null) &&
          this.modelfiltro[i].filtro != "" &&
          this.modelfiltro[i].filtro != null
        ) {
          validate = true;
        } else if (
          (this.modelfiltro[i].contenido != "" ||
            this.modelfiltro[i].contenido != null) &&
          this.modelfiltro[i].filtro != "" &&
          this.modelfiltro[i].filtro != null
        ) {
          this.busquedacompleta = true;
        }
      }
      // Consultas a Ejecutar
      if (!validate) {
        this.consult = true;
        this.getConsultData();
      } else {
        this.$swal({
          icon: "warning",
          title: "Campos Incompletos.",
          html: " Hay campos que se encuentran incompletos o no contiene el respecitivo filtro.",
        });
      }
    },
    // Consulta Tablero
    async getConsultData() {
      this.desserts = [];
      this.selected = [];
      this.progreso = true;
      var data = {
        filtrado: this.modelfiltro,
        parametro2: this.paramiframeuno,
        busquedacompleta: this.busquedacompleta,
      };
      this.axios
        .post("/ActivosO/Seguros/Get/", data)
        .then((result) => {
          this.desserts = result.data;
        })
        .catch((error) => {
          const registro = error.response.data;
          const mensajeerror =
            registro.Mensaje || registro.ExceptionMessage || registro;
          switch (error.response.status) {
            case 404:
              this.$swal({
                icon: "warning",
                title: "Consulta inexistente.",
                html: mensajeerror,
              });
              break;
            default:
              this.$swal({
                icon: "error",
                title: "Error al consultar",
                html:
                  " El servidor ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                  mensajeerror +
                  "</code></small>",
              });
              break;
          }
        })
        .finally(() => {
          this.progreso = false;
          this.dialogframe = false;
        });
    },
    // Item editar
    editItem(item, iconoelegido) {
      this.componenteview = iconoelegido;
      this.infoitem = item;
      switch (iconoelegido) {
        case 0:
          this.editedIndex = this.desserts.indexOf(item);
          this.editedItem = Object.assign({}, item);
          this.dialogframecreate = true;
          break;
        case 1: //Clientes
          this.iconodialogbtn = "mdi-account";
          this.titledialogbtn = "Clientes";
          this.dialogframeboton = true;
          this.llaves.TypeDocument_ID = this.infollaves.TypeDocument_ID;
          this.llaves.Document_ID = this.infollaves.Document_ID;
          break;
        case 2: //Contratos
          this.iconodialogbtn = "mdi-note";
          this.titledialogbtn = "Contratos";
          this.dialogframeboton = true;
          this.llaves.Contrato = this.infollaves.Contrato;
          break;
        case 3: //Activos
          this.iconodialogbtn = "mdi-home-group";
          this.titledialogbtn = "Activos";
          this.dialogframeboton = true;
          this.llaves.Ref_1 = this.infollaves.Ref_1;
          break;
        case 4: //Documentos
          this.iconodialogbtn = "mdi-file-search";
          this.titledialogbtn = "Anexar Documentos";
          this.dialogframeboton = true;
          this.llaves.TypeDocument_ID = this.infollaves.TypeDocument_ID;
          this.llaves.Document_ID = this.infollaves.Document_ID;
          this.llaves.Contrato = this.infollaves.Contrato;
          this.llaves.Ref_1 = this.infollaves.Ref_1;
          //this.llaves.IDPoliza = this.infollaves.IDPoliza;
          this.llaves.IDPoliza = item.SeguroID.toString();
          break;
        case 5: //Consulta Documentos
          this.iconodialogbtn = "mdi-note";
          this.titledialogbtn = "Consulta de documentos";
          this.dialogframeboton = true;
          this.llaves.TypeDocument_ID = this.infollaves.TypeDocument_ID;
          this.llaves.Document_ID = this.infollaves.Document_ID;
          this.llaves.Contrato = this.infollaves.Contrato;
          this.llaves.Ref_1 = item.Ref_1;
          //this.llaves.IDPoliza = this.infollaves.IDPoliza;
          this.llaves.IDPoliza = item.SeguroID.toString();
          break;
      }
    },
    // Confirmación de eliminación
    Eliminar() {
      if (this.selected.length != 0 && this.selected != null) {
        this.$swal({
          icon: "question",
          title: "Eliminar Información",
          html: "¿Está seguro que desea eliminar la información seleccionada?<br>Esta acción no se puede deshacer luego de confirmarla.",
          confirmButtonText: "Sí",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
        }).then((result) => {
          if (result.isConfirmed) {
            this.getDelete();
          }
        });
      } else {
        this.$swal({
          icon: "info",
          title: "Seleccione la fila a eliminar",
          html: "Lo sentimos, debe seleccionar la celda o celdas para eliminar el registro.",
        });
      }
    },
    // Consulta las eliminaciones
    async getDelete() {
      this.axios
        .delete("/ActivosO/Seguros/", { data: this.selected })
        .then((response) => {
          if (response.data === "Exito") {
            this.$swal({
              icon: "success",
              title: "Información Eliminada",
              html: "La información se ha eliminado correctamente.",
            });
            this.getConsultData();
            this.selected = [];
          } else {
            this.$swal({
              icon: "error",
              title: "Error al guardar los datos",
              html: response.data.toString(),
            });
          }
        })
        .catch((e) =>
          this.$swal({
            icon: "error",
            title:
              "No se logro la eliminación debido a que tiene datos relacionados",
            html:
              "Lo sentimos, ocurrió un error al intentar consultar los datos del proceso:<br><small><code>" +
              e.toString() +
              "</code></small>",
          })
        );
    },
    ///////////////////////////////////////////////// Métodos de acciones ///////////////////////////////////////////
    // Limpiar campos
    reset() {
      this.busquedacompleta = false;
      this.$refs.form.reset();

      if (this.pageiframe) {
        // Tipo de documento
        if (
          this.infollaves.TypeDocument_ID != null &&
          this.infollaves.TypeDocument_ID != ""
        ) {
          this.modelfiltro[0].filtro = "=";
          this.modelfiltro[0].contenido =
            this.infollaves.TypeDocument_ID.toString();
          this.modelfiltro[0].lectura = true;
          this.modelfiltro[0].clear = false;
        }
        // Documento
        if (
          this.infollaves.Document_ID != null &&
          this.infollaves.Document_ID != ""
        ) {
          this.modelfiltro[1].filtro = "=";
          this.modelfiltro[1].contenido = this.infollaves.Document_ID;
          this.modelfiltro[1].lectura = true;
          this.modelfiltro[1].clear = false;
        }
        // Contrato
        if (
          this.infollaves.Contrato != null &&
          this.infollaves.Contrato != ""
        ) {
          this.modelfiltro[2].filtro = "=";
          this.modelfiltro[2].contenido = this.infollaves.Contrato;
          this.modelfiltro[2].lectura = true;
          this.modelfiltro[2].clear = false;
        }
        // Activo
        if (this.infollaves.Ref_1 != null && this.infollaves.Ref_1 != "") {
          this.modelfiltro[3].filtro = "=";
          this.modelfiltro[3].contenido = this.infollaves.Ref_1;
          this.modelfiltro[3].lectura = true;
          this.modelfiltro[3].clear = false;
        }
        // Seguro
        if (
          this.infollaves.IDPoliza != null &&
          this.infollaves.IDPoliza != ""
        ) {
          this.modelfiltro[12].filtro = "=";
          this.modelfiltro[12].contenido = this.infollaves.IDPoliza.toString();
          this.modelfiltro[12].lectura = true;
          this.modelfiltro[12].clear = false;
        }
      }
    },

    // Cargue Combo
    CargueCombo() {
      var arrayTabla = this.$store.getters.MTablaSeleccion;
      this.ArrayTipoSeguro = arrayTabla.filter(
        (item) => item.Valor != null && item.TablaId == 24
      );

      this.ArrayEstado = arrayTabla.filter(
        (item) => item.Valor != null && item.TablaId == 25
      );

      this.ArrayTipoPoliza = arrayTabla.filter(
        (item) => item.Valor != null && item.TablaId == 26
      );

      this.ArrayClasePoliza = arrayTabla.filter(
        (item) => item.Valor != null && item.TablaId == 27
      );
    },

    // Cerrar combos
    CerrarCombos() {
      this.dialogframeboton = false;
      this.llaves.TypeDocument_ID = null;
      this.llaves.Document_ID = null;
      this.llaves.Primer_Apellido = null;
      this.llaves.Primer_Nombre = null;
      this.llaves.Segundo_Nombre = null;
      this.llaves.Solicitud = null;
      this.llaves.Contrato = null;
      this.llaves.Ref_1 = null;
      this.llaves.Ref_2 = null;
      this.llaves.Ref_3 = null;
      this.llaves.IDServicio = null;
      this.llaves.IDPoliza = null;
    },

    // Busca los parametros de la pagina
    parametrospaginas() {
      var page = this.$store.getters.userperfil.paginainfo;
      if (page.param1) {
        var splitparam1 = page.param1.split("");
        this.param1 = splitparam1;
      }
    },

    // Parametros Iframe
    parametrosiframe() {
      console.log(this.infollaves);
      // Tipo de documento
      if (
        this.infollaves.TypeDocument_ID != null &&
        this.infollaves.TypeDocument_ID != ""
      ) {
        this.modelfiltro[0].filtro = "=";
        this.modelfiltro[0].contenido =
          this.infollaves.TypeDocument_ID.toString();
        this.modelfiltro[0].lectura = true;
        this.modelfiltro[0].clear = false;
      }
      // Documento
      if (
        this.infollaves.Document_ID != null &&
        this.infollaves.Document_ID != ""
      ) {
        this.modelfiltro[1].filtro = "=";
        this.modelfiltro[1].contenido = this.infollaves.Document_ID;
        this.modelfiltro[1].lectura = true;
        this.modelfiltro[1].clear = false;
      }
      // Contrato
      if (this.infollaves.Contrato != null && this.infollaves.Contrato != "") {
        this.modelfiltro[2].filtro = "=";
        this.modelfiltro[2].contenido = this.infollaves.Contrato;
        this.modelfiltro[2].lectura = true;
        this.modelfiltro[2].clear = false;
      }
      // Activo
      if (this.infollaves.Ref_1 != null && this.infollaves.Ref_1 != "") {
        this.modelfiltro[3].filtro = "=";
        this.modelfiltro[3].contenido = this.infollaves.Ref_1;
        this.modelfiltro[3].lectura = true;
        this.modelfiltro[3].clear = false;
      }
      // Seguro
      if (this.infollaves.IDPoliza != null && this.infollaves.IDPoliza != "") {
        this.modelfiltro[12].filtro = "=";
        this.modelfiltro[12].contenido = this.infollaves.IDPoliza.toString();
        this.modelfiltro[12].lectura = true;
        this.modelfiltro[12].clear = false;
      }
      // Tipo Seguro
      if (this.TipoSeguro != null && this.TipoSeguro != "") {
        this.modelfiltro[4].filtro = "=";
        this.modelfiltro[4].contenido = this.TipoSeguro;
        this.modelfiltro[4].lectura = true;
        this.modelfiltro[4].clear = false;
      }
      var splitparam1 = this.infopermisos.split("");
      this.param1 = splitparam1;
      this.ValidateCampos();
    },
    // Consulta Aseguradora
    async getAseguradora() {
      this.ArrayNotaria = [];
      this.axios
        .get("/Personas/Cliente/CD2/1")
        .then((response) => {
          this.ArrayNotaria = response.data;
        })
        .catch((e) => console.log(e));
    },
  },
  mounted() {
    if (!this.pageiframe) {
      this.parametrospaginas();
    } else {
      this.parametrosiframe();
    }
  },
};
</script>
